import { css } from '@emotion/react'

export default css`
	margin-bottom: 2em;
`;
